import React from 'react';
import './workStatDay.css';
import { useTranslation } from 'react-i18next';


export const WorkStatDay = ({ employeeWorkDetails }) => {

    const {t} = useTranslation();

    // Get today's date
    const today = new Date();
    const todayFormatted = formatDate(today); // Format today's date as "Day Month Date, Year"

    // Filter work details for today
    const todayWorkDetails = employeeWorkDetails.filter(detail => {
        const workDate = new Date(detail.work_date);
        return isSameDay(workDate, today);
    });

    // Calculate total worked hours and minutes for today
    let totalMinutes = todayWorkDetails.reduce((total, detail) => {
        if (detail.work_duration && typeof detail.work_duration === 'string') {
            const durationParts = detail.work_duration.split(':');
            if (durationParts.length === 3) {
                const hours = parseInt(durationParts[0], 10) || 0;
                const minutes = parseInt(durationParts[1], 10) || 0;
                total += hours * 60 + minutes;
            }
        }
        return total;
    }, 0);

    const totalHours = Math.floor(totalMinutes / 60);
    const totalRemainingMinutes = totalMinutes % 60;

    return (
        <div className='WorkStat-body'>
            <div className='WorkStat-worked-headerbody'>
                <div className='WorkStat-worked-header'>
                   <span>{t("employeeWorkDetails_today")}</span>
                </div>
            </div>
            <div className='WorkStat-worked-duration'>
                {totalHours} Hrs {totalRemainingMinutes} Mins
            </div>
            <div className='WorkStat-worked-footer'>
                {todayFormatted}
            </div>
        </div>
    );
};

// Helper function to check if two dates are the same day
const isSameDay = (date1, date2) => {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
};

// Helper function to format date as "Day Month Date, Year" (e.g., "Wednesday, June 14, 2024")
const formatDate = (date) => {
    const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};

export default WorkStatDay;
